import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { saveAs } from 'file-saver';
import { config } from '../../../../config';
import { Payment } from './payment.model';
import { Debt } from '../debts';

interface BPayResponse {
  data: {
    biller_code: string;
    crn: string;
  };
}

export interface PaymentResponse {
  data: Payment;
}

@Injectable()
export class PaymentService {
  constructor(private http: HttpClient) { }

  get(filter, page) {
    return this.http
      .get<any>(`${config.apiLocation}/v1/payments?status=${filter}&page=${page}&format=basic`);
  }

  bpay(debt: Debt) {
    return this.http
      .post<BPayResponse>(`${config.apiLocation}/v1/debts/${debt.id}/bpay`, {})
      .map(res => res.data);
  }

  schedule(payment: Payment, scheduled_at: string): Observable<PaymentResponse> {
    return this.http
      .post<PaymentResponse>(`${config.apiLocation}/v1/payments/${payment.id}/schedule`, { scheduled_at });
  }

  /**
   * Resolve a payment
   *
   * @param payment
   */
  resolve(payment: Payment) {
    return this.http
      .get(`${config.apiLocation}/v1/payments/${payment.id}/resolve`);
  }

  /**
   * Return a payment receipt pdf
   * @param  payment Pass a payment to the function for selection
   * @return
   */
  receipt(payment: Payment) {
    let mediaType = 'application/pdf';
    return this.http
      .get(`${config.apiLocation}/v1/payments/${payment.id}/receipt`, { responseType: 'blob' })
      .subscribe(
        (response) => {
            var blob = new Blob([response], { type: mediaType });
            saveAs(blob, `receipt-number-${payment.receipt}`);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/payments/payment.service.ts